import { Button, Dropdown, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth0 } from "@auth0/auth0-react";

import "../../Assets/scss/components/user-menu-dropdown.scss";
import { useState } from "react";
import UserLogoutActionService from "../../Services/UserAction/LogoutActionService";
import TourGuide from "../TourGuide";
import { useTheme } from "../../Context/ThemeContext";

// component to display user dropdown toggle button
const UserDropdownButton = () => {

    // Functions
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { theme, toggleTheme } = useTheme();
    const { logout, isAuthenticated } = useAuth0();

    // Redux Data
    const { user, accessToken, currentWebsite, websites } = useSelector((store: StoreProptypes) => store);

    const dataPermission = websites?.filter((i: any) => i?.website_domain === currentWebsite?.domain)
    const currentSettings = dataPermission && dataPermission[0]?.permissions?.find((i: any) => i?.name === "settings");

    // State
    const [showLogOutConfirmModal, setShowLogOutConfirmModal] = useState<boolean>(false);

    // function to close logout confirmation modal
    const handleLogOutConfirmModalClose = () => {
        setShowLogOutConfirmModal(false);
    }

    // function to show logout confirmation modal
    const handleLogOutConfirmModalShow = () => {
        setShowLogOutConfirmModal(true);
    }

    // function to handle logout action
    const handleLogout = () => {
        if (accessToken) {
            console.log("isAuthenticated", isAuthenticated);
            //service to perform user logout
            //logout({ logoutParams: { returnTo: window.location.origin } })
            //logout({ logoutParams: { returnTo: window.location.origin } })
            if(isAuthenticated){
                UserLogoutActionService(accessToken, dispatch, navigate, t, handleLogOutConfirmModalClose, logout);
            }
            else{
                UserLogoutActionService(accessToken, dispatch, navigate, t, handleLogOutConfirmModalClose);
            }

        }
    }

    return (
        <>
        <TourGuide />
            {user && (
                <>
                    <Dropdown className="aioa_dashboard-user-dropdown-btn tour-profile">


                        <OverlayTrigger
                            placement='auto'
                            overlay={<Tooltip id="user_tooltip">
                                <strong>
                                    {user.name}
                                </strong>
                                {user.company_name ? <> <br /> {user.company_name}</> : ''}
                            </Tooltip>}
                        >
                            <Dropdown.Toggle id="user-menu-dropdown">
                                <div className="aioa_dashboard-user-dropdown-btn-wrapper">
                                    <div className="aioa_dashboard-user-dropdown-btn-icon">
                                        {user.name && user.name.charAt(0)}
                                    </div>
                                    <div className="aioa_dashboard-user-dropdown-btn-text">
                                        <span className="aioa_dashboard-user-dropdown-btn-user-name">{user.name}</span>
                                        <span className="aioa_dashboard-user-dropdown-btn-company-name">
                                            {user.company_name}
                                        </span>
                                    </div>
                                </div>
                            </Dropdown.Toggle>
                        </OverlayTrigger>



                        <Dropdown.Menu>
                            <Dropdown.Item as={`div`} className="aioa_dashboard-user-dropdown-btn-text">
                                <span className="aioa_dashboard-user-dropdown-btn-user-name">{user.name}</span>
                                <span className="aioa_dashboard-user-dropdown-btn-company-name">{user.company_name}</span>
                            </Dropdown.Item>
                            <Dropdown.Divider />
                            {/* <Dropdown.Item as={Link} to={window.location.href} onClick={toggleTheme}>
                                {theme === "light" ? "🌙 Dark Mode" : "☀️ Light Mode"}
                            </Dropdown.Item> */}
                            <Dropdown.Item as={Link} to="/front/edit-profile">
                                <i className="material-symbols-outlined" aria-hidden="true">person</i>
                                <span>{t("Profile")}</span>
                            </Dropdown.Item>
                                <Dropdown.Item as={Link} to="/front/security">
                                <i className="material-symbols-outlined" aria-hidden="true">Security</i>
                                <span>{t("security")}</span>
                            </Dropdown.Item>
                           
                            {!(user?.department === 1 && user?.parent_id === 1) && (
                                <Dropdown.Item as={Link} to="/front/user-activity">
                                    <i className="material-symbols-outlined" aria-hidden="true">schedule</i>
                                    <span>{t("User Activity")}</span>
                                </Dropdown.Item>
                            )}
                            {(user?.parent_id === 0 || user?.parent_id === 1) && !(user?.department === 1 && user?.parent_id === 1) && user?.website_lists?.length > 0 && (
                            <Dropdown.Item as={Link} to="/front/usermanagement">
                                <i className="material-symbols-outlined" aria-hidden="true">admin_panel_settings</i>
                                <span>{t("User Management")}</span>
                            </Dropdown.Item>
                            )}
                            {(user?.department === 1 && user?.parent_id === 0) && (
                            <Dropdown.Item as={Link} to="/front/adminmanagement">
                                <i className="material-symbols-outlined" aria-hidden="true">admin_panel_settings</i>
                                <span>{t("Admin Management")}</span>
                            </Dropdown.Item>
                            )}
                             {((user?.parent_id === 0 ||  user?.parent_id === 1) || currentSettings?.name === "settings") && (<>
                            {(currentWebsite?.platform !== 'wix' && currentWebsite?.platform !== 'shopify' && currentWebsite?.platform !== 'plesk' && currentWebsite?.platform !== 'AWS')
                                ? <Dropdown.Item as={Link} to="/front/settings">
                                    <i className="material-symbols-outlined" aria-hidden="true">settings</i>
                                    <span>{t('Settings')}</span>
                                </Dropdown.Item>
                                : <></>
                            } </>)}
                            <Dropdown.Item as={`button`} className="logout-btn" onClick={() => handleLogOutConfirmModalShow()}>
                                <i className="material-symbols-outlined" aria-hidden="true">logout</i>
                                <span>{t("Logout")}</span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    <Modal show={showLogOutConfirmModal} onHide={handleLogOutConfirmModalClose}>
                        <Modal.Header>
                            <Modal.Title>{t("Logout")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{t('logout modal msg')}</Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={() => handleLogout()} size="lg" className="aioa_dashboard-icon-btn">
                                <div className="aioa_dashboard-btn-icon"><i className="material-symbols-outlined" aria-hidden="true">check</i></div>
                                <div className="aioa_dashboard-btn-text">{t('yes btn label')}</div>
                            </Button>
                            <Button variant="danger" onClick={handleLogOutConfirmModalClose} size="lg" className="aioa_dashboard-icon-btn">
                                <div className="aioa_dashboard-btn-icon"><i className="material-symbols-outlined" aria-hidden="true">close</i></div>
                                <div className="aioa_dashboard-btn-text">{t('no btn label')}</div>
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>
            )}
        </>
    )
}

export default UserDropdownButton;
